import { defineComponent } from "vue";
import { useRegisterTestStore } from "@/store/RegisterTestStore";
import FloatingCard from "@/components/Shared/RegisterTest/FloatingCard/FloatingCard.vue";
import { mapWritableState } from "pinia";
import ThemesHelper from "@/helpers/ThemesHelper";
import AlertBox from "@/components/AlertBox/AlertBox.vue";

export default defineComponent({
  props: {
    active: {
      type: Boolean,
    },
  },
  components: {
    FloatingCard,
    AlertBox,
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ["canJumpNext"]),
  },
  data() {
    return {
      imagePath: "",
      StepContent: ThemesHelper.getThemeParams("testStepTwoContents"),
    };
  },
  methods: {
    isValidStep(): boolean {
      // no validation
      return true;
    },
    setAnimationType(animationName: string) {
      setTimeout(() => {
        const baseModal: any = this.$refs["base-modal"];
        switch (animationName) {
          case "setNextDismissAnimation":
            baseModal.setNextDismissAnimation();
            break;
          case "setNextShowAnimation":
            baseModal.setNextShowAnimation();
            break;
          case "setPreviousDismissAnimation":
            baseModal.setPreviousDismissAnimation();
            break;
          case "setPreviousShowAnimation":
            baseModal.setPreviousShowAnimation();
            break;
        }
      }, 1);
    },
  },
  mounted() {
    const array: any = JSON.parse(JSON.stringify(this.StepContent));
    this.imagePath = array.image
      ? require(`@/assets/themes/${array.image}`)
      : "";
  },
});
